
import { defineComponent } from 'vue';
import CustomAlert from './Alert.vue';

export default defineComponent({
  name: 'GlobalAlert',

  components: { CustomAlert },

  props: {
    dismissible: { type: Boolean, default: false },
    text: { type: String, required: true },
    type: { type: String, required: true },
    id: { type: Number, required: true },
    timed: { type: Boolean, default: false },
    totalShowTime: { type: Number, default: 3000 },
  },

  data: () => ({
    showTime: 0,
    interval: null as number | null,
  }),

  methods: {
    close() {
      this.$emit('close', this.id);
    },
  },
});
